import { render, staticRenderFns } from "./PopupPhitomonitoring.vue?vue&type=template&id=8213bf86&scoped=true"
import script from "./PopupPhitomonitoring.vue?vue&type=script&lang=js"
export * from "./PopupPhitomonitoring.vue?vue&type=script&lang=js"
import style0 from "./PopupPhitomonitoring.vue?vue&type=style&index=0&id=8213bf86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8213bf86",
  null
  
)

export default component.exports